import { render, staticRenderFns } from "./ScoreBreakdown.vue?vue&type=template&id=0c5c9f9c&scoped=true"
import script from "./ScoreBreakdown.vue?vue&type=script&lang=js"
export * from "./ScoreBreakdown.vue?vue&type=script&lang=js"
import style0 from "./ScoreBreakdown.vue?vue&type=style&index=0&id=0c5c9f9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5c9f9c",
  null
  
)

export default component.exports